import * as angular from "angular";

angular
  .module('bringoz.admin.cancellation-reasons')
  .config(cancellationReasonsConfig);

/* @ngInject */
function cancellationReasonsConfig($stateProvider, moment) {

  // $stateProvider

}
